import { BadgeField, RecordField, Show, TextField } from "@/components/admin"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
const BlogShow: React.FC = function () {
  return (
    <Show title={null}>
      <div className="w-full p-2 flex justify-center">
        <Card className="w-250">
          <CardHeader>
            <CardTitle>
              <TextField source="title" />
            </CardTitle>
            <CardDescription>3 min read</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="aspect-auto rounded-xl bg-gray-100 mb-8">
              <RecordField
                label=""
                render={record => (
                  <img
                    src={record.image}
                    alt={record.title}
                    className="w-full object-cover"
                  />
                )}
              />
            </div>
            <p className="text-muted-foreground text-sm">
              <TextField source="content" />
            </p>
          </CardContent>
          <CardFooter>
            <BadgeField source="created_at" />
          </CardFooter>
        </Card>
      </div>
    </Show>
  )
}

export default BlogShow
